module.exports = __webpack_public_path__ + "static/dragonborn-1-19c2bc27f29dced95b0f8cbee14d1d8b.png";